import type { ComponentProps, FunctionComponent } from 'react';
import { cn } from '../../utils/cn.ts';


export const Fullscreen: FunctionComponent<ComponentProps<'div'>> = (props) => {
  const { className, ...rest } = props;

  return (
    <div
      className={cn(
        'fixed inset-0 z-[1000] flex min-h-dvh flex-col items-center justify-center bg-secondary-50',
        className,
      )}
      {...rest}
    />
  );
};
